module.exports = __webpack_public_path__ + "static/media/traffic.50bf52a4.jpeg";